
import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { DisplayTable } from './DisplayTable.tsx';
import { Select } from '@mui/material';
import { MenuItem } from '@mui/material';
import { sanitize_id } from '../../misc/CommonFunctions.ts';

export var LoggedIn = false;

const TABS = ['Crop', 'Moa Code', 'Monitoring Intensity', 'Pest', 'Monitoring Type', 'Resistance Frequency', 'Resistance Factor', 'Resistance Mechanism', 'Resistance Relevance', 'Geograhic Distribution', 'Contributing Companies'];
const TAB_NAME_CROP = 'Crop';
const TAB_NAME_MOA_CODE = 'Moa Code';
const TAB_NAME_MONITORING_INTENSITY = 'Monitoring Intensity';
const TAB_NAME_PEST = 'Pest';
const TAB_NAME_MONITORING_TYPE = 'Monitoring Type';
const TAB_NAME_RESISTANCE_FREQUENCY = 'Resistance Frequency';
const TAB_NAME_RESISTANCE_FACTOR = 'Resistance Factor';
const TAB_NAME_RESISTANCE_MECHANISM = 'Resistance Mechanism';
const TAB_NAME_RESISTANCE_RELEVANCE = 'Resistance Relevance';
const TAB_NAME_GEOGRAPHIC_DISTRIBUTION = 'Geograhic Distribution';
const TAB_NAME_CONTRIBUTING_COMPANIES = 'Contributing Companies';


const PAGE_TO_URL = {
    [TAB_NAME_CROP]: 'crop',
    [TAB_NAME_MOA_CODE]: 'moa',
    [TAB_NAME_MONITORING_INTENSITY]: 'monitoring_intensity',
    [TAB_NAME_PEST]: 'pest',
    [TAB_NAME_MONITORING_TYPE]: 'monitoring_type',
    [TAB_NAME_RESISTANCE_FREQUENCY]: 'resistance_frequency',
    [TAB_NAME_RESISTANCE_FACTOR]: 'resistance_factor',
    [TAB_NAME_RESISTANCE_MECHANISM]: 'resistance_mechanism',
    [TAB_NAME_RESISTANCE_RELEVANCE]: 'resistance_relevance',
    [TAB_NAME_GEOGRAPHIC_DISTRIBUTION]: 'geo_distribution',
    [TAB_NAME_CONTRIBUTING_COMPANIES]: 'companies',
}

const lookups = Object.keys(PAGE_TO_URL);


export function DataManVocabPage() {

    const [value, setValue] = React.useState(0);
    const [selectedLookup, setSelectedLookup] = React.useState<string>(lookups[6]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div>

            <Select
                id="lookup-select"
                value={selectedLookup}
                onChange={(event) => setSelectedLookup(event.target.value)}
            >
                {lookups.map((lookup) => {
                    return <MenuItem
                        id={sanitize_id(lookup)}
                        key={lookup}
                        value={lookup}>{lookup}</MenuItem>
                })}
            </Select>
            <br /><br />

            <DisplayTable tabName={selectedLookup} db_name_of_vocab={PAGE_TO_URL[selectedLookup]} />
        </div >
    )

}

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;


    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}


